import { render } from "./SidebarNavItem.vue?vue&type=template&id=2f65bdd3&scoped=true"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js"

import "./SidebarNavItem.vue?vue&type=style&index=0&id=2f65bdd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f65bdd3"]])

export default __exports__